import { Button, Flex, InputTypeTextReduced } from '@gmg/gmg-react-components';
import { ChangeEvent, FunctionComponent, useRef, useState } from 'react';
import styled from 'styled-components';
import { loadFileContentAsString } from './fileReader';

export interface UploadLocalFileProps {
    id: string;
    label: string;
    acceptedFileFormat: string;
    buttonProps: { title: string; variant: 'primary' | 'secondary' };
    onFinishUpload: (file: UploadedFile) => void;
};

export interface UploadedFile { fileName: string; content: string }

const UploadLocalFile: FunctionComponent<UploadLocalFileProps> = ({ onFinishUpload, ...props }) => {
    const [selectedFile, setSelectedFile] = useState<UploadedFile>();
    const inputFileRef = useRef<HTMLInputElement>(null);

    const onOpenFileDialogClick = () => {
        if (!inputFileRef.current) return;
        inputFileRef.current.click();
    };

    const handleSelectFileClick = async (e: ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) return;
        const selectedFileFromDisk = e.target.files[0];
        const content = await loadFileContentAsString(selectedFileFromDisk);
        const uploadedFile = { fileName: selectedFileFromDisk.name, content: content };
        setSelectedFile(uploadedFile);
        onFinishUpload(uploadedFile);

        e.target.value = ''; // we're calling the function onchange/oninput. If you upload the same file the value of the file input HAS NOT changed from the previous upload and therefore isn't triggered. This also explains why it works if we upload a different file. =>  we can work around this by resetting the input field's value after you read the file.
    };

    return (
        <div>

            <StyledLabel
                className="px10_400_weak"
                htmlFor={props.id}
            >
                {props.label}
            </StyledLabel>

            <Flex height="36px" gap='20px' mt='8px'>
                <Flex flexGrow={1}>
                    <InputTypeTextReduced
                        width='100%'
                        id={props.id}
                        placeholder='No file selected'
                        defaultValue={selectedFile?.fileName || ''}
                    />
                </Flex>
                <input
                    type="file"
                    id={props.id}
                    accept={props.acceptedFileFormat}
                    onChange={handleSelectFileClick}
                    ref={inputFileRef}
                    style={{ display: 'none' }}
                    placeholder='hidden input'
                />
                <Button
                    variant={props.buttonProps.variant}
                    onClick={onOpenFileDialogClick}
                >
                    {props.buttonProps.title}
                </Button>
            </Flex>
        </div>
    );
};

const StyledLabel = styled.label`
    margin-top: 30px;
    box-sizing: border-box;
    height: 20px;
`;

export default UploadLocalFile;